module.exports = __webpack_public_path__ + "8ad0c541f3299550cfcfcd98607c7d40.svg";